import { getDate } from '../header/utils'

// Keep in sync with the original in charts repo in app/constants/common.ts
function getMinutesFromMarketTimeObject({ hours, minutes }: { hours: number; minutes: number }) {
  return hours * 60 + minutes
}
const PREMARKET_START_MINUTES = getMinutesFromMarketTimeObject({ hours: 4, minutes: 0 })
const AFTERMARKET_END_MINUTES = getMinutesFromMarketTimeObject({ hours: 20, minutes: 0 })
export const MARKET_START_MINUTES = getMinutesFromMarketTimeObject({ hours: 9, minutes: 30 })
export const MARKET_END_MINUTES = getMinutesFromMarketTimeObject({ hours: 16, minutes: 0 })

/*
 * Keep in sync with the original (Utils static method) in charts repo in app/utils.ts
 * See line 19, we use getDate instead of convertLocalToNyTime
 */
export function isStockFastRefreshAvailable(
  premarketMinutesStart = PREMARKET_START_MINUTES,
  aftermarketMinutesEnd = AFTERMARKET_END_MINUTES,
  bufferMinutes = 30
) {
  const date = getDate()
  const dayOfWeek = date.getDay()
  const currentDayMinutes = date.getHours() * 60 + date.getMinutes()

  const isWeekend = dayOfWeek === 0 || dayOfWeek === 6
  const marketStartMinutes = premarketMinutesStart > 0 ? premarketMinutesStart : MARKET_START_MINUTES
  const marketEndMinutes = aftermarketMinutesEnd > 0 ? aftermarketMinutesEnd : MARKET_END_MINUTES
  const isOpen = marketStartMinutes - bufferMinutes <= currentDayMinutes
  const isClosed = marketEndMinutes + bufferMinutes <= currentDayMinutes
  return !isWeekend && isOpen && !isClosed
}
